export const removeDuplicates = <T, K extends keyof T>(
	arr: T[],
	key: K
): T[] => {
	const seen = new Set<T[K]>();
	return arr.filter((item) => !seen.has(item[key]) && seen.add(item[key]));
};
